






































import Vue from 'vue'
import Component from 'vue-class-component'
import { Getter, Action } from 'vuex-class'

import Input3InputWithUpdateButton from '../../../../../html-components-type-1-basic/basic-type-3-input/input-3-input-with-update-button.vue'
import UserInterface3ErrorMessage from '../../../../../html-components-type-1-basic/basic-type-4-user-interface/user-interface-3-error-message.vue'
import Input4PropertyIdMapper from '../../../../../html-components-type-1-basic/basic-type-3-input/input-4-property-id-mapper.vue'

const namespace = 'digitalCurrency'

@Component({
  components: {
    Input3InputWithUpdateButton,
    UserInterface3ErrorMessage,
    Input4PropertyIdMapper
  }
})
class PersonalInformationResourceItem5CurrencyExchangeInformationSettings extends Vue {
  @Getter('getActiveDigitalCurrencyAccount', { namespace }) getActiveDigitalCurrencyAccount?: any
  @Getter('getDigitalCurrencyAccountSettings', { namespace }) getDigitalCurrencyAccountSettings?: any

  @Action('updateDigitalCurrencyAccountSettings', { namespace }) updateDigitalCurrencyAccountSettings?: any

  showErrorMessage: boolean = false
  errorMessage: string = 'errorMessage'

  updateAccountSettings (propertyId: string, propertyValue: any) {
    this.updateDigitalCurrencyAccountSettings({
      propertyId,
      propertyValue
    }).catch((errorMessage: any) => {
      this.errorMessage = errorMessage
      this.showErrorMessage = true
    })
  }
}

export default PersonalInformationResourceItem5CurrencyExchangeInformationSettings

